import { RulaMetadata } from "src/store/createAssessmentSlice";

export const REBA_SCORE_WORST_CSS_BORDER_CLASS = "reba-score--worst";
export const REBA_SCORE_VERY_BAD_CSS_BORDER_CLASS = "reba-score--very-bad";
export const REBA_SCORE_BAD_CSS_BORDER_CLASS = "reba-score--bad";
export const REBA_SCORE_OK_CSS_BORDER_CLASS = "reba-score--ok";
export const REBA_SCORE_EXCELLENT_CSS_BORDER_CLASS = "reba-score--excellent";
export const CREATE_RULA_ADDITIONAL_INFO_INITIAL_STATE = {
  isLeftArmSupportedOrPersonLeaning: 0,
  isLeftLowerArmAcrossMidlineOrOutToSide: 0,
  isRightArmSupportedOrPersonLeaning: 0,
  isRightLowerArmAcrossMidlineOrOutToSide: 0,
  rightWristAwkwardPosition: -1,
  leftWristAwkwardPosition: -1,
  leftWristTwistPosition: -1,
  rightWristTwistPosition: -1,
  leftWristBentTwisted: 0,
  rightWristBentTwisted: 0,
  armMuscleUseSelection: "",
  armForceLoadSelection: "",
  isNeckTwisted: 0,
  isTrunkTwisted: 0,
  isLegFeetNotSupported: -1,
  lowerBodyMuscleUseSelection: "",
  lowerBodyForceLoadSelection: "",
  comment: "",
};
export const ADDITIONAL_INFO_INITIAL_REQUIRED: (keyof RulaMetadata)[] = [
  "rightWristAwkwardPosition",
  "leftWristAwkwardPosition",
  "leftWristTwistPosition",
  "rightWristTwistPosition",
  "armMuscleUseSelection",
  "armForceLoadSelection",
  "isLegFeetNotSupported",
  "lowerBodyMuscleUseSelection",
  "lowerBodyForceLoadSelection",
];
